export default "__VITE_ASSET__VSqeY0VV__"